module.exports = __webpack_public_path__ + "img/LTS_AG.f206de39.gif";